import { Stack } from '@mui/material';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedMatchups } from './store/actions';
import { Check } from '@mui/icons-material';

const Matchups = () => {
  const { selectedSlate } = useSelector((state: any) => state.common);

  return (
    <Stack bgcolor='#1C1C1C' maxWidth='100%' padding={{ xs: '10px', lg: '12px 20px' }} rowGap='8px'>
      <Stack direction='row'justifyContent='space-between' fontSize='18px' fontWeight={500} columnGap='4px' sx={{ display: { xs: 'none', lg: 'flex' } }}>
        <Stack>
          Build and Simulate a Lineup for <Stack display='contents' component='span' color='#FFBDC5'>{selectedSlate?.site} - {selectedSlate?.name}</Stack>
        </Stack>
        {
          selectedSlate.sport.toLowerCase() === 'mlb' && (
            <Stack direction='row' alignItems='center' columnGap='18px'>
              <Stack direction='row' alignItems='center' columnGap='6px'>
                <Check style={{ color: '#61FFAC', fontSize: '12px' }} />
                Lineups Confirmed
              </Stack>
              <Stack direction='row' alignItems='center' columnGap='6px'>
                <Stack sx={{ backgroundColor: '#FBFF39', height: '8px', width: '8px', borderRadius: '100%' }} />
                Lineups Pending
              </Stack>
            </Stack>
          )
        }
      </Stack>
      {
        Object.keys(selectedSlate).length > 0 && selectedSlate?.matchupInfo?.length > 0 && (
          <Stack direction='row' alignItems='center' columnGap='15px' sx={{ overflowX: 'auto', '&::-webkit-scrollbar': { display: { xs: 'none', lg: 'block' } }, scrollbarWidth: { xs: 'none', lg: 'auto' } }} width='100%'>
            <MatchupBox />
            {selectedSlate.matchupInfo.map((matchup: any) => (
              <div key={matchup.homeTeamAbbrev + matchup.awayTeamAbbrv}>
                <MatchupBox matchup={matchup} />
              </div>
            ))}
          </Stack>
        )
      }
    </Stack>
  )
}

const MatchupBox = ({ matchup }: { matchup?: any }) => {
  const dispatch = useDispatch();
  const { selectedMatchups } = useSelector((state: any) => state.lineupBuilder);
  const { selectedSlate } = useSelector((state: any) => state.common);
  const [matchupIsSelected, setMatchupIsSelected] = React.useState(false);


  const onClick = () => {
    if (!matchup) {
      dispatch(setSelectedMatchups([]))
    } else if (selectedMatchups.includes(matchup?.awayTeamAbbrev) && selectedMatchups.includes(matchup?.homeTeamAbbrev)) {
      const prevSelectedMatchups = selectedMatchups.filter((team: string) => team !== matchup.awayTeamAbbrev && team !== matchup.homeTeamAbbrev)
      dispatch(setSelectedMatchups(prevSelectedMatchups))
    } else {
      dispatch(setSelectedMatchups([...selectedMatchups, matchup.awayTeamAbbrev, matchup.homeTeamAbbrev]))
    }
  }

  React.useEffect(() => {
    if (selectedMatchups.includes(matchup?.awayTeamAbbrev) && selectedMatchups.includes(matchup?.homeTeamAbbrev)) {
      setMatchupIsSelected(true)
    } else if (selectedMatchups.length === 0 && !matchup) {
      setMatchupIsSelected(true)
    } else {
      setMatchupIsSelected(false)
    }
  }, [selectedMatchups]);

  return (
    <Stack color='white' alignItems='center' justifyContent='center' padding={{ xs: '4px 12px', lg: "10px 15px" }} border={matchupIsSelected ? '1px solid #A10012' : ''} bgcolor={matchupIsSelected ? 'rgba(161, 0, 18, 0.10)' : 'rgba(255, 255, 255, 0.08)'} borderRadius='10px' sx={{ cursor: 'pointer' }} onClick={onClick}>
      {
        matchup ? (
          <Stack direction='column' alignItems='center' rowGap='8px'>
            <Stack fontSize={{ xs: '10px', lg: '12px' }} fontWeight={{ xs: 300, lg: 400 }} color="rgba(255, 255, 255, 0.87)">{new Date(matchup.gameTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} EST</Stack>
            <Stack direction='row' columnGap='10px'>
              <Stack direction='row' alignItems='center' columnGap='10px' fontSize={{ xs: '12px', lg: '16px' }} fontWeight={500}>
                {matchup.awayTeamAbbrev}
                {matchup.awayTeamLogo && 
                  <Stack width={{ xs: '14px', lg: '20px' }} height={{ xs: '14px', lg: '20px' }}>
                    <img src={matchup.awayTeamLogo} alt={matchup.awayTeamAbbrev} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  </Stack>
                }
                {
                  selectedSlate.sport?.toLowerCase() === 'mlb' && (
                    <>
                      {matchup.awayTeamLineupConfirmed ? <Check style={{ color: '#61FFAC', fontSize: '12px' }} /> : <Stack sx={{ backgroundColor: '#FBFF39', height: '8px', width: '8px', borderRadius: '100%' }} />}
                    </>
                  )
                }
              </Stack>
              <Stack fontSize={{ xs: '10px', lg: '12px' }} fontWeight={400} color="rgba(255, 255, 255, 0.70)">@</Stack>
              <Stack direction='row' alignItems='center' columnGap='10px' fontSize={{ xs: '12px', lg: '16px' }} fontWeight={500}>
              {
                  selectedSlate.sport?.toLowerCase() === 'mlb' && (
                    <>
                      {matchup.homeTeamLineupConfirmed ? <Check style={{ color: '#61FFAC', fontSize: '12px' }} /> : <Stack sx={{ backgroundColor: '#FBFF39', height: '8px', width: '8px', borderRadius: '100%' }} />}
                    </>
                  )
                }
                {matchup.homeTeamAbbrev}
                {matchup.homeTeamLogo && 
                  <Stack width={{ xs: '14px', lg: '20px' }} height={{ xs: '14px', lg: '20px' }}>
                    <img src={matchup.homeTeamLogo} alt={matchup.homeTeamAbbrev} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  </Stack>                
                }
              </Stack>
            </Stack>
            {/* <Stack direction='row' alignItems='center' columnGap='2px' fontSize={{ xs: '10px', lg: '12px' }} fontWeight={400} color="rgba(255, 255, 255, 0.70)">{matchup.lineupConfirmed ? <>Lineups Confirmed <Check style={{ color: '#61FFAC', fontSize: '12px' }} /></> : <>Lineups Pending <Stack sx={{ backgroundColor: '#FBFF39', height: '8px', width: '8px', borderRadius: '100%' }} /> </>}</Stack> */}
          </Stack>

        ) : (
          <Stack direction='row' alignItems='center' fontSize={{ xs: '12px', lg: '18px' }} height='32.5px' fontWeight={500} whiteSpace='nowrap'>All Matchups</Stack>
        )
      }
    </Stack>
  )
}

export default Matchups